// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Flv23","bigScore":"style__bigScore__5Kvjz","targetIndicator":"style__targetIndicator__IMJta"};